export enum ToastTypes {
  SUCCESS = 'success',
  DANGER = 'danger'
}
